export default __webpack_public_path__ + "static/media/screen_whatsapp_5.b5461fe4.png";